import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-903d9b30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spinner-overlay" }
const _hoisted_2 = ["src"]

import { computed } from "vue";

type SpinnerType = "Wheel" | "Dots";


export default /*#__PURE__*/_defineComponent({
  __name: 'loading-spinner',
  props: {
    size: { default: "64px" },
    type: { default: "Wheel" }
  },
  setup(__props: any) {

const props = __props;
const spinnerSize = computed(() => props.size || "64px");

const spinnerType = computed(() => {
  switch (props.type) {
    case "Dots":
      return "/Lottie/lottie-loading-dots.json";
    case "Wheel":
    default:
      return "/Lottie/wheel.json";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("lottie-player", {
      autoplay: "",
      loop: "",
      src: spinnerType.value,
      style: _normalizeStyle(`width:${spinnerSize.value}; height:${spinnerSize.value};`)
    }, null, 12, _hoisted_2)
  ]))
}
}

})